module.exports = __webpack_public_path__ + "img/success_check.64804123.svg";